"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.array(zod_1.z.object({
    plantStressLngLat: zod_1.z.string(),
    maxLowStress: zod_1.z.number().nullable(),
    minHighStress: zod_1.z.number().nullable(),
}));
//# sourceMappingURL=update.js.map